import { render, staticRenderFns } from "./_TravelInsurance.vue?vue&type=template&id=b9503dd6&"
import script from "./_TravelInsurance.vue?vue&type=script&lang=js&"
export * from "./_TravelInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports